import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function StickyCtaBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-313">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-[#0B0E13]/95 backdrop-blur-md border-t border-[#D4A843]/30 shadow-[0_-4px_20px_rgba(0,0,0,0.5)] pb-safe" data-id="element-314">
          <div className="max-w-4xl mx-auto px-4 py-3 md:py-4 flex items-center justify-between" data-id="element-315">
            <div className="flex flex-col md:flex-row md:items-center md:space-x-4" data-id="element-316">
              <div className="flex items-baseline space-x-2" data-id="element-317">
                <span className="text-xl font-bold text-[#F5F0E8]" data-id="element-318">
                  $6.36 USD
                </span>
                <span className="text-sm text-[#8B8578] line-through decoration-[#C75B3A]" data-id="element-319">
                  $27
                </span>
              </div>
              <span className="text-xs text-[#D4A843] font-medium uppercase tracking-wide hidden md:block" data-id="element-320">
                Precio de lanzamiento
              </span>
            </div>

            <a href="https://www.betterbysteps.com/cart/44195063332957:1" target="_blank" rel="noopener noreferrer" className="flex items-center bg-[#D4A843] hover:bg-[#E8BC5A] text-[#0B0E13] font-bold px-5 py-2.5 rounded-lg transition-colors text-sm md:text-base shadow-lg shadow-[#D4A843]/20 no-underline" data-id="element-321">
              <span data-id="element-322">Obtener Kit</span>
              <ArrowRight className="ml-2 w-4 h-4" data-id="element-323" />
            </a>
          </div>
          {/* Mobile urgency text below price */}
          <div className="md:hidden text-center pb-2" data-id="element-324">
            <span className="text-[10px] text-[#D4A843] font-medium uppercase tracking-wide" data-id="element-325">
              Precio de lanzamiento
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}